import axios from 'axios';
import prepareQueryString from '@/utils/prepareQueryString';
import { subject as an } from '@casl/ability';
import { adminPath } from '@/api/helpers/apiPath';

export default {
  getTemplates(params) {
    return axios.get(adminPath('/quote_templates?') + prepareQueryString(params)).then((response) => {
      return {
        quoteTemplates: response.data.map((template) => an('QuoteTemplate', template)),
        total: response.headers['x-pagination'] && JSON.parse(response.headers['x-pagination']).total,
      };
    });
  },
  get(id) {
    return axios.get(adminPath(`/quote_templates/${id}`)).then((response) => an('QuoteTemplate', response.data));
  },
  create(data) {
    return axios
      .post(adminPath('/quote_templates'), {
        ...data,
      })
      .then((response) => an('QuoteTemplate', response.data));
  },
  update(id, data) {
    return axios
      .patch(adminPath(`/quote_templates/${id}`), {
        ...data,
      })
      .then((response) => an('QuoteTemplate', response.data));
  },
  getTemplateItems(params) {
    return axios.get(adminPath('/quote_template_items?') + prepareQueryString(params)).then((response) => {
      return {
        quoteTemplateItems: response.data.map((item) => an('QuoteTemplateItem', item)),
        total: response.headers['x-pagination'] && JSON.parse(response.headers['x-pagination']).total,
      };
    });
  },
};
